"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRegulatoryAssessmentAdminListDto = instanceOfRegulatoryAssessmentAdminListDto;
exports.RegulatoryAssessmentAdminListDtoFromJSON = RegulatoryAssessmentAdminListDtoFromJSON;
exports.RegulatoryAssessmentAdminListDtoFromJSONTyped = RegulatoryAssessmentAdminListDtoFromJSONTyped;
exports.RegulatoryAssessmentAdminListDtoToJSON = RegulatoryAssessmentAdminListDtoToJSON;
exports.RegulatoryAssessmentAdminListDtoToJSONTyped = RegulatoryAssessmentAdminListDtoToJSONTyped;
const RegulatoryAssessmentAdminDto_1 = require("./RegulatoryAssessmentAdminDto");
/**
 * Check if a given object implements the RegulatoryAssessmentAdminListDto interface.
 */
function instanceOfRegulatoryAssessmentAdminListDto(value) {
    if (!('assessments' in value) || value['assessments'] === undefined)
        return false;
    return true;
}
function RegulatoryAssessmentAdminListDtoFromJSON(json) {
    return RegulatoryAssessmentAdminListDtoFromJSONTyped(json, false);
}
function RegulatoryAssessmentAdminListDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'assessments': (json['assessments'].map(RegulatoryAssessmentAdminDto_1.RegulatoryAssessmentAdminDtoFromJSON)),
    };
}
function RegulatoryAssessmentAdminListDtoToJSON(json) {
    return RegulatoryAssessmentAdminListDtoToJSONTyped(json, false);
}
function RegulatoryAssessmentAdminListDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'assessments': (value['assessments'].map(RegulatoryAssessmentAdminDto_1.RegulatoryAssessmentAdminDtoToJSON)),
    };
}
//# sourceMappingURL=RegulatoryAssessmentAdminListDto.js.map